<img
  *ngIf="(country || '') | country:'flag'"
  [src]="(country || '') | country:'flag'"
  alt="flag"
  [width]="width"
/>
